const state = {
  mobileMenu:"",
  activeSection:undefined,
  activePage:undefined,
  showWelcome:true,
  currentSectionNavigation:[],
  currentSectionTitle:"",
  pitchView:{
    ref:"mi1",
    title:"Pitch View Club",
    nav:[
      {
        title: "Intro",
        url: "pitch-view-club"
      },
      {
        title: "Specs",
        url: "pitch-view-club-specs"
      },
      {
        title: "Views",
        url: "pitch-view-club-views"
      },
      {
        title: "Benefits",
        url: "pitch-view-club-benefits"
      },        
      {
        title: "Reserve Yours",
        url: "pitch-view-club-investment"
      }
    ]
  },
  tunnelClub:{
    ref:"mi1",
    title:"Tunnel Club",
    nav:[
      {
        title: "Intro",
        url: "tunnel-club"
      },
      {
        title: "Specs",
        url: "tunnel-club-specs"
      },
      {
        title: "Views",
        url: "tunnel-club-views"
      },
      {
        title: "Benefits",
        url: "tunnel-club-benefits"
      },        
      {
        title: "Reserve Yours",
        url: "tunnel-club-investment"
      }
    ]
  },
  cincinnatusClub:{
    ref:"mi1",
    title:"Cincinnatus Club",
    nav:[
    {
      title: "Intro",
      url: "cincinnatus-club"
    },
    {
      title: "Specs",
      url: "cincinnatus-club-specs"
    },
    {
      title: "Views",
      url: "cincinnatus-club-views"
    },
    {
      title: "Benefits",
      url: "cincinnatus-club-benefits"
    },      
    {
      title: "Reserve Yours",
      url: "cincinnatus-club-investment"
    }
  ]
  },
  firstFinancialClub:{
    ref:"mi1",
    title:"<img src='" + require('@/assets/icons/FirstFinancialClub.svg') + "' alt height='50'/>",
    nav:[
    {
      title: "Intro",
      url: "first-financial-club"
    },
    {
      title: "Specs",
      url: "first-financial-club-specs"
    },
    {
      title: "Views",
      url: "first-financial-club-views"
    },
    {
      title: "Benefits",
      url: "first-financial-club-benefits"
    },      
    {
      title: "Reserve Yours",
      url: "first-financial-club-investment"
    }
  ]
  },
  bailey:{
    ref:"mi3",
    title:"The Bailey",
    nav:[
    {
      title: "Intro",
      url: "bailey"
    },
    {
      title: "Specs",
      url: "bailey-specs"
    },
    {
      title: "Views",
      url: "bailey-views"
    },
    {
      title: "Benefits",
      url: "bailey-benefits"
    },      
    {
      title: "Claim Yours",
      url: "bailey-investment"
    }
  ]
  },
  history:{
    ref:"mi0",
    title:"History",
    nav:[
    {
      title: "Club Rise",
      url: "club-rise"
    },              
    {
      title: "Club Philosophy",
      url: "club-philosophy"
    },
  ]
  },
  ourFans:{
    ref:"mi0",
    title:"Our Fans",
    nav:[
    {
      title: "This is Cincy",
      url: "this-is-cincy"
    },                
    {
      title: "Attendance",
      url: "our-fans"
    },
    {
      title: "Demographics",
      url: "demographics"
    },          
    {
      title: "Neighborhood",
      url: "neighborhood"
    },          
  ]
  },
  westEndStadium:{
    ref:"mi0",
    title:"About West End Stadium",
    nav:[
    {
      title: "By the Numbers",
      url: "by-the-numbers"
    },              
    {
      title: "Exterior LED",
      url: "about-west-end-stadium"
    },            
  ]
  },
  foodBeverage:{
    ref:"mi4",
    title:"Food & Beverage",
    nav:[
      {
        title: "Intro",
        url: "food-and-beverage"
      },
      {
        title: "Gallery",
        url: "food-and-beverage-gallery"
      },
    ]
  },
  reservedSeating:{
    ref:"mi2",
    title:"Reserved Seating",
    nav:[
      {
        title: "Pricing",
        url: "reserved-seating"
      },
      {
        title: "Specs",
        url: "reserved-seating-specs"
      },
      {
        title: "Views",
        url: "reserved-seating-views"
      },
      {
        title: "Benefits",
        url: "reserved-seating-benefits"
      },      
      {
        title: "Claim Yours",
        url: "reserved-seating-investment"
      }
    ]
  },
  menuItems: [    
    {
      ref:"mi2",
      title: "Reserved Seating",
      status: "normal",
      subnav: [
        {
          title: "Pricing",
          url: "reserved-seating"
        }
      ]
    },
    {
      ref:"mi3",
      title: "The Bailey",
      status: "normal",
      subnav: [
        {
          title: "Intro",
          url: "bailey"
        }
      ]
    },
    {
      ref:"mi1",
      title: "Clubs",
      status: "normal",
      subnav: [
        {
          title: "Tunnel Club",
          url: "tunnel-club"
        },
        {
          title: "Pitch View Club",
          url: "pitch-view-club"
        },
        {
          title: "Cincinnatus Club",
          url: "cincinnatus-club"
        },
        {
          title: "First Financial Club",
          url: "first-financial-club"
        }
      ]
    },
    {
      title: "Virtual Tour",
      subnav: [
            {
              title: "Virtual Tour",
              url: "virtual-tour"
        },
      ]
    },    
    {
      ref:"mi4",
      title: "Food & Beverage",
      status: "normal",
      subnav: [
        {
          title: "Intro",
          url: "food-and-beverage"
        }
      ]
    },                  
    {
      ref:"mi0",
      title: "The Team & Stadium",
      status: "normal",
      subnav: [
        {
          title: "History",
          url: "club-rise"
        },
        {
          title: "This is Cincy",
          url: "this-is-cincy"
        },
        {
          title: "About West End Stadium",
          url: "by-the-numbers"
        }
      ]
    },             
  ]
}

const getters = {
    //getLetterModal: (state) => state.showLetterModal,
}

const actions = {
    /*
    onClickLetterModal({commit}, payload){
        commit('onClickLetterModal', payload)
    },
    */    
}

const mutations = {
    /*
    onClickLetterModal: (state, payload) => {
        state.showLetterModal = payload
    },
    */
}

export default {
    state,
    getters,
    actions,
    mutations
}

// use $store.dispatch('onClickInvoiceModal', true)